import amaLog from '../helpers/log';
import { capitalizeFirst, isEmpty } from '../helpers/utils';

const patternRegularSubdomain = /^(?:(?!www).)*$/m;

let amaSite: string = undefined;
let amacc: string = undefined;
let amaHost: string = undefined;
let amaDomain: string = undefined;
let amaSubDomain: string = undefined;
let amaTestSite: string = undefined;

export const isVideoPage = (): boolean => {
  const path = window?.location.pathname || '';
  return path.includes('/video/');
};

const patternSubdomain = /^(\w+\.\w+\.\w+)$/m;
/**
 * Check if the current location.host is a regular (www) subdomain
 * or a blog
 * @return {boolean}
 */
export const hostIsSpecificSubdomain = (): boolean =>
  patternSubdomain.test(window.location.host) && patternRegularSubdomain.test(window.location.host);

export const isBlog = hostIsSpecificSubdomain;

const getCategory = (): string => location.pathname.split('/')[1] || 'general';

const getTestSite = (): undefined | string => {
  if (amaTestSite) return amaTestSite;
  const testSiteCookie = 'adsDfpIdTestSite';

  if (window?.location?.search) {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('dfp_id')) {
      const dfpId: string = urlParams.get('dfp_id');
      if (dfpId.length > 0) {
        amaTestSite = dfpId;
        sessionStorage.setItem(testSiteCookie, amaTestSite);
      }
    }
  } else if (sessionStorage.getItem(testSiteCookie)) {
    const dfpId: string = sessionStorage.getItem(testSiteCookie);
    if (dfpId.length > 0) {
      amaTestSite = dfpId;
    }
  }
  return amaTestSite;
};

export const isTestSite = (): boolean => amaTestSite !== undefined;

export const getHostName = (): string => amaHost;

export const getSiteName = (): string => amaSite;

export const isSubDomain = (): boolean => !!amaSubDomain;

const containsCategoryPath = () => location.pathname.split('/')[1] !== '';

export const resolveHost = (adScriptConfHost?: string) => {

  const winDefinedHost = window.ama?.hostName || window.hostName;

  amaLog('resolveHost optHost definedHost', adScriptConfHost, winDefinedHost);

  const host = (!isEmpty(winDefinedHost) && winDefinedHost) || (!isEmpty(adScriptConfHost) && adScriptConfHost) || window.location.hostname;
  const parts = host.split('.');
  const secondLevelDomain = parts.length > 1 ? parts[parts.length - 2] : undefined;
  const topLevelDomain = parts.length > 0 ? parts[parts.length - 1] : undefined;

  const definedSubDomain = window.ama?.subDomain || window.subDomain;
  // Use subdomain if defined by the site
  const useSub = !isEmpty(definedSubDomain);

  const domainName = secondLevelDomain ? `${secondLevelDomain}.${topLevelDomain}` : undefined;  // elle.se
  const subDomainName = useSub && domainName ? `${definedSubDomain}.${domainName}` : undefined; // elsa.elle.se

  amaHost = subDomainName || domainName || undefined; // elsa.elle.se / elle.se
  amaSite = useSub && definedSubDomain || secondLevelDomain; // elsa / elle
  amaDomain = domainName || undefined; // elle.se
  amaSubDomain = definedSubDomain || undefined; // elsa

  if(!amaHost || !amaSite) {
    console.error(`Ads bundle failed resolve amaHost: ${amaHost} and/or amaSite: ${amaSite}`);
  }

  amaLog('resolveHost ', parts, amaSite, amaHost, amaDomain, amaSubDomain);
}

export const getDomain = (): string => {

  if(!isEmpty(amaDomain)) return amaDomain;

  amaLog('getDomain', amaDomain);

  return amaDomain;
};

export const getSubdomainAdwatchName = (): string => {
  const components = amaHost.split('.');
  if (components.length !== 3) {
    throw Error(`Unexpected length of amaHost ${amaHost}`);
  }
  const [subdomain, domain] = components;
  const capitalizedDomain = capitalizeFirst(domain);
  return `${subdomain}${capitalizedDomain}`;
};

export const setDfpSection = (section: string | undefined = window.ama?.dfpSection): string => {
  let dfpSection = 'general'; // elle.se

  if (section) {
    dfpSection = section;
  } 
  else if (isSubDomain()) {

    dfpSection = amaSubDomain;
  }
  else if (containsCategoryPath()) {

      dfpSection = getCategory();
  }
  amaLog('dfpSection', dfpSection);

  return dfpSection;
};

type PathIdExceptions = {
  [site: string]: {
    consent: string;
    nonConsent: string;
  };
};

const getPathIdExceptions = () => {
  const pathIdExceptions: {[countryCode: string]: PathIdExceptions } = {
    'dk':{
      'familiejournal.dk': {
        consent: 'familiejournal',
        nonConsent: 'Non_familiejournal'
      },
      'spisbedre.dk': {
        consent: 'Spisbedre_2018',
        nonConsent: 'Spisbedre_2018'
      },
      'femina.dk': {
        consent: 'femina',
        nonConsent: 'femina'
      },
      'udeoghjemme.dk': {
        consent: 'udeoghjemme',
        nonConsent: 'non_udeoghjemme'
      },
      'seoghoer.dk': {
        consent: 'seoghoer.dk',
        nonConsent: 'non_seoghoer'
      },
      'billedbladet.dk': {
        consent: 'billedbladet',
        nonConsent: 'non_billedbladet'
      },
      'vielskerserier.dk': {
        consent: 'vielskerserier',
        nonConsent: 'non_vielskerserier'
      },
      'isabellas.dk': {
        consent: 'isabellas.dk',
        nonConsent: 'non_isabellas.dk'
      }
    }
  }
  return pathIdExceptions[resolveCountryCode()] || {};  
}

export const resolveAdUnitPathGamSiteId = (configGamSiteId: string = 'global', hasConsent: boolean) => {
  let resolveId = configGamSiteId;
  const testSite = getTestSite();
  const pathIdExceptions = getPathIdExceptions();

  if(testSite) {
    resolveId = testSite;
  }
  else if (amaDomain && pathIdExceptions[amaDomain]) {
    resolveId = hasConsent ? pathIdExceptions[amaDomain].consent : pathIdExceptions[amaDomain].nonConsent;
  }
  else if (resolveId.includes('global') || isSubDomain()) {
    resolveId = getDomain();
  }

  amaLog(`adUnitPathGamSiteId: /${resolveId}/`);

  return resolveId;
};

export const getVideoAdUnitPath = (config: any, videoOnly: boolean, adSettings: any): string => {
  let sitePath = config.gamSiteId;
  let categoryPath = '';

  const pathIdExceptions = getPathIdExceptions();

  if(resolveCountryCode() === 'se') {
    categoryPath = videoOnly ? 'videopage' : (adSettings.firstVideoAutoStart === false ? 'video-clicktoplay' : 'video');
  }
  else if (amaDomain && pathIdExceptions[amaDomain]) {
    sitePath = pathIdExceptions[amaDomain].consent;
  }
  window.amav.adPath = `/${config.networkCode}/${sitePath}/${categoryPath}`;

  return window.amav.adPath;
}

export const resolveCountryCode = (): string => {

  if (typeof amacc !== 'undefined') return amacc;

  if(amaHost) {
    const exceptions: { [key: string]: string;} = {'mabra.com' : 'mabra.se'};

    amacc = (exceptions[amaHost] ?? amaHost).split('.').pop();     
  }

  amaLog('resolveCountryCode calculated ... ', amacc);

  return amacc;
}
export const isFinishSite = (): boolean => getSiteName() === 'seiska';

export const isSeOcelot = (): boolean => amacc === 'se' && !isSubDomain() && getSiteName() !== 'recept';
